// src/onboardingConfig.js
export const SETUP_STEPS = [
  { key: "mfa",          name: "Enable Two-Factor Authentication",  route: "/settings?tab=account" },
  { key: "plaid",        name: "Connect your bank accounts",        route: "/settings?tab=plaid" },
  { key: "notifications",name: "Review notification settings",      route: "/settings?tab=notifications" },
];

export const FEATURE_STEPS = [
  { key: "dashboard",   name: "Dashboard overview",    route: "/dashboard",
    blurb: "Your month-at-a-glance. See alerts, action items, and projections." },
  { key: "budget",      name: "Budget",                route: "/budget",
    blurb: "Set monthly targets, track rollups, and fine-tune subcategories." },
  { key: "transactions",name: "Transactions",          route: "/transactions",
    blurb: "Confirm categories quickly. Rules reduce manual work over time." },
  { key: "reports",     name: "Reports",               route: "/reports",
    blurb: "Trends, insights, and month-over-month views." },
  { key: "rules",       name: "Rules",                 route: "/rules",
    blurb: "Automate matching by vendor, category, amount." },
  { key: "goals",       name: "Goals",                 route: "/goals",
    blurb: "Create savings or payoff targets and track progress." },
];

export const stepIndex = (arr, key) => Math.max(0, arr.findIndex(s => s.key === key));